module.exports = __webpack_public_path__ + "static/media/Target.61ff3e83.svg";